'use es6';

function toggleable(fn) {
  var enabled = true;

  var isEnabled = function isEnabled() {
    return enabled;
  };

  var setEnabled = function setEnabled(state) {
    enabled = state;
  };

  var toggleableFn = function toggleableFn() {
    return fn(isEnabled).apply(void 0, arguments);
  };

  return Object.assign(toggleableFn, {
    setEnabled: setEnabled
  });
}

export default toggleable;